<template>
  <b-dropdown-header test-id="al-dropdown-header">
    <slot />
  </b-dropdown-header>
</template>
<script>
import BdropdownHeader from 'bootstrap-vue';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BdropdownHeader
  }
};
</script>

<style lang="scss">
.dropdown-header {
  color: color(black, lighten, 3);
  display: inline-block;
  font-size: 12.8px;
  margin: 0;
  padding: 0;
  padding-left: 12px;
  text-transform: uppercase;
}
</style>
